import Keyboard from './Keyboard';

export type { KeyboardProps, KeyboardCssVars } from './Keyboard';

export default Keyboard;
